document.addEventListener('DOMContentLoaded', () => {
  const init = () => {
    document.documentElement.removeAttribute('style');
    document.documentElement.classList.add('is-loaded');
    const cover = document.getElementById('cover');

    setTimeout(() => {
      if (document.querySelectorAll('.js-reviews').length > 0) {
        window.carousels();
      }
      if (cover) {
        cover.remove();
      }

    }, 250);
  };
  window.addEventListener('load', init);

}, false);